<template>
  <div class="bind-position-component">
    <el-form label-width="100px" ref="dataForm" :model="formData">
      <el-form-item label="职位名称">
        <el-select size="mini" v-model="formData.id" :disabled="disableUpdate">
          <el-option v-for="item in positionList" :key="item.id" :label="item.positionName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="mt-10" label="职位员工">
        <el-select size="mini" style="width:100%" filterable :filter-method="filterFunction" multiple v-model="formData.userIdList">
          <el-option v-for="item in memberList" :key="item.userId" :label="item.nickName" :value="item.userId"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="ta-c mt-10">
      <el-button size="mini" @click="$emit('closeBox')">取消</el-button>
      <el-button size="mini" type="primary" @click="submitForm()">确认</el-button>
    </div>
  </div>
</template>

<script>
import {
  Req_GetPositionList,
  Req_GetTeamerList,
  Req_SetMembersToPosition
} from '@/request/organize'
import {
  deepClone
} from '@/util'
export default {
  data() {
    return {
      formData:{
        userIdList:[],
        id:'',
        congfigOrRelieve:1
      },
      positionList:[],
      memberList:[],
      copyMemberList:[],
      bindTypeList:{
        10:'部门经理',
        20:'主管组长'
      }
    }
  },
  props:{
    bindType:{},
    disableUpdate:{
      type:Boolean,
      default:true
    },
    form:{
      type:Object,
      default:() => {}
    }
  },
  created() {
    this.getList()
    this.getAllUser()
  },
  methods: {
    getList(){
      Req_GetPositionList().then(res => {
        this.positionList = res
        if(this.bindType){
          const type = this.bindTypeList[this.bindType]
          res.find(item => {
            if(item.positionName === type){
              this.formData.id = item.id
              this.formData.userIdList = item.userIdList
              return true
            }
          })
        }
      }).catch(err => {
        this.$catchErr(err)
      })
    },
    filterFunction(value){
      this.memberList = []
      const selectedItem = []
      if(!value) return this.memberList = this.copyMemberList
      this.copyMemberList.forEach(item => {
        const val = {
          data:item
        }
        // console.log(this.formData.userIdList)
        if(this.$fuzzyFilter(val,value)){
          this.memberList.push(item)
        }else if(this.formData.userIdList && this.formData.userIdList.indexOf(item.userId) !== -1){
          selectedItem.push(item)
        }
      });
      this.memberList = [...this.memberList,...selectedItem]
    },
    getAllUser(){
      Req_GetTeamerList().then(res => {
        this.memberList = res
        this.copyMemberList = deepClone(res)
      }).catch(err => {
        this.$catchErr(err)
      })
    },
    submitForm(){
      Req_SetMembersToPosition(this.formData).then(res => {
        this.$message.success('绑定成功')
        this.$emit('configSuccess')
      }).catch(err => this.$catchErr(err))
    },
  },
  computed:{

  },
  watch:{

  },
  components:{

  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/BindPositionComponent.vue